import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Sparkles } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CommitteeBioCard = ({ committeeName }) => {
  const [bio, setBio] = useState(null);
  const [building, setBuilding] = useState(true);
  const timer = useRef(null);

  useEffect(() => {
    let cancelled = false;
    setBio(null);
    setBuilding(true);
    const poll = async (attempt) => {
      try {
        const r = await axios.get(`${API}/committees/${encodeURIComponent(committeeName)}/bio`, {
          validateStatus: (s) => s === 200 || s === 202,
        });
        if (cancelled) return;
        if (r.status === 202) {
          if (attempt < 12) timer.current = setTimeout(() => poll(attempt + 1), 5000);
          else setBuilding(false);
          return;
        }
        setBio(r.data);
        setBuilding(false);
      } catch {
        if (!cancelled) setBuilding(false);
      }
    };
    poll(0);
    return () => { cancelled = true; clearTimeout(timer.current); };
  }, [committeeName]);

  if (!bio && !building) return null;

  return (
    <div className="whip-surface rounded-xl border border-white/10 p-5 mb-6" data-testid="committee-bio-card">
      <div className="flex items-center gap-2 mb-3">
        <Sparkles className="w-4 h-4 text-orange-400" />
        <p className="text-[11px] font-mono font-bold uppercase tracking-[0.2em] text-white/60">Jurisdiction & Current Priorities</p>
        {bio?.generatedAt && (
          <span className="ml-auto text-[10px] font-mono text-white/35" data-testid="committee-bio-updated">
            Updated {new Date(bio.generatedAt).toLocaleDateString()}
          </span>
        )}
      </div>
      {bio ? (
        <p className="text-sm md:text-base leading-relaxed text-white/85" data-testid="committee-bio-summary">{bio.summary}</p>
      ) : (
        <div className="flex items-center gap-3 text-sm text-white/55" data-testid="committee-bio-building">
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-orange-400" />
          Writing this committee's overview, usually under 30 seconds.
        </div>
      )}
    </div>
  );
};
